export default function Footer() {
    return (
        <footer className="bg-gray-800 text-white p-4 w-full">
            <div className="flex flex-col gap-4 items-center justify-center md:flex-row md:gap-8">
                <div className="flex flex-col items-center md:items-start">
                    <p className="text-center md:text-left">&copy; {new Date().getFullYear()} - AK API - Nguyen Anh Kiet.</p>
                </div>
                <div className="flex flex-col items-center md:items-start">
                    <span>
                        Community:{" "}
                        <a
                            href="https://t.me/+6e_EVAca9GgwMmM1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline hover:text-blue-300 break-all"
                        >
                            https://t.me/+6e_EVAca9GgwMmM1
                        </a>
                    </span>
                    <span>
                        Telegram:{" "}
                        <a
                            href="https://t.me/anhkiet9052"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline hover:text-blue-300 break-all"
                        >
                            https://t.me/anhkiet9052
                        </a>
                    </span>
                </div>
                <div className="flex flex-col items-center md:items-start">
                    <span>
                        Messenger:{" "}
                        <a
                            href="https://m.me/anhkiet9052"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline hover:text-blue-300 break-all"
                        >
                            https://m.me/anhkiet9052
                        </a>
                    </span>
                    <span>
                        Facebook:{" "}
                        <a
                            href="https://fb.com/anhkiet9052"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline hover:text-blue-300 break-all"
                        >
                            https://fb.com/anhkiet9052
                        </a>
                    </span>
                    <span>
                        Email:{" "}
                        <a
                            href="mailto:tml25092004@gmail.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline hover:text-blue-300 break-all"
                        >
                            tml25092004@gmail.com
                        </a>
                    </span>
                </div>
            </div>
        </footer>
    );
}